import React, { createContext, useContext, useMemo, useState } from "react";

interface IActivities {
    cardType: string;
    activityName: string;
    date: string;
    allocation: string;
    situation?: string;
    status?: string;
    defer?: boolean;
    justification?: string;
}

interface IActivityManagementContextData {
    activityInformation: string;
    activities: IActivities[];
    setActivities: (activities: IActivities[]) => void;
}

const ActivitiesManagementContext =
    createContext<IActivityManagementContextData>({
        activityInformation: "",
        activities: [],
        setActivities: () => {},
    });

export function useActivitiesManagement(): IActivityManagementContextData {
    return useContext(ActivitiesManagementContext);
}

interface ActivitiesManagementProviderProps {
    children: React.ReactNode;
}

export const ActivitiesManagementProvider: React.FC<
    ActivitiesManagementProviderProps
> = ({ children }) => {
    const [activities, setActivities] = useState<IActivities[]>([]);
    const [activityInformation, setActivityInformation] = useState<string>("");

    const contextValue = useMemo(() => {
        return {
            activities,
            setActivities,
            activityInformation,
            setActivityInformation,
        };
    }, [activities, activityInformation]);

    return (
        <ActivitiesManagementContext.Provider value={contextValue}>
            {children}
        </ActivitiesManagementContext.Provider>
    );
};
